<template>
  <div class="auth">
    <div class="sign-in" v-if="!hasUser">
      <div class="list-group">
        <li class="list-group-item list-group-item-warning">ご利用いただくには登録が必要です。</li>
      </div>
      <Mail  />
      <div class="btn-sns">
        <button type="button" class="btn btn-info" @click="googleLogin">Google認証</button>
      </div>
    </div>
    <div class="sign-out" v-else>
      <button type="button" class="btn btn-warning" @click="logout">ログアウト</button>
    </div>
  </div>
</template>
<script>
import Mail from '@/components/Auth/Mail.vue'
import firebase from 'firebase'

export default {
  name: 'auth',
  components: {
    Mail
  },
  data() {
    return {
      hasUser: false
    }
  },
  methods: {
    googleLogin(){
      let provider = new firebase.auth.GoogleAuthProvider();
      let vue = this;
      firebase.auth().signInWithPopup(provider).then(function () {
        vue.$router.push('/');
      });
    },
    logout(){
      firebase.auth().signOut();
    },
    checkHasUser(){
      let vue = this;
      firebase.auth().onAuthStateChanged((user)=>{
        if (user){
          vue.hasUser = true;
        }else {
          vue.hasUser = false;
        }
      });
    }
  },
  computed: {
  },
  created() {
    this.checkHasUser();
    console.log(this.hasUser);
  }
}
</script>
<style scoped>
.btn-sns {
  margin-top: 10px;
}
</style>
